import { observer } from "mobx-react-lite";

import { ColumnLayoutSection } from "./ColumnLayoutSection";
import { ColumnVisibilitySection } from "./ColumnVisibilitySection";
import { ColumnPinningSection } from "./ColumnPinningSection";
import { ViewHeightSection } from "./ViewHeightSection";
import { TipSection } from "./TipSection";

export const SideBar = observer(() => (
  <div className="flex h-full w-full max-w-[250px] flex-col border-l border-gray-200 bg-gray-50/50 p-3">
    <div className="mb-3">
      <h3 className="mb-0.5 text-sm font-semibold text-gray-800">Display Actions</h3>
      <p className="text-xs text-gray-500">Manage table layout and columns</p>
    </div>

    <div className="flex flex-1 flex-col justify-between space-y-2">
      <div className="flex flex-col space-y-1">
        <ViewHeightSection />
        <ColumnLayoutSection />
        <ColumnVisibilitySection />
        <ColumnPinningSection />
      </div>
    </div>

    <TipSection />
  </div>
));
